"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = speakableActivity;

function speakableActivity(activity) {
  return activity && activity.from && activity.type === 'message';
}
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy9kZWZpbml0aW9ucy9zcGVha2FibGVBY3Rpdml0eS5qcyJdLCJuYW1lcyI6WyJzcGVha2FibGVBY3Rpdml0eSIsImFjdGl2aXR5IiwiZnJvbSIsInR5cGUiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBZSxTQUFTQSxpQkFBVCxDQUEyQkMsUUFBM0IsRUFBcUM7QUFDbEQsU0FBT0EsUUFBUSxJQUFJQSxRQUFRLENBQUNDLElBQXJCLElBQTZCRCxRQUFRLENBQUNFLElBQVQsS0FBa0IsU0FBdEQ7QUFDRCIsInNvdXJjZVJvb3QiOiJjb3JlOi8vLyIsInNvdXJjZXNDb250ZW50IjpbImV4cG9ydCBkZWZhdWx0IGZ1bmN0aW9uIHNwZWFrYWJsZUFjdGl2aXR5KGFjdGl2aXR5KSB7XG4gIHJldHVybiBhY3Rpdml0eSAmJiBhY3Rpdml0eS5mcm9tICYmIGFjdGl2aXR5LnR5cGUgPT09ICdtZXNzYWdlJztcbn1cbiJdfQ==